module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_SL-1fae95cda72bbf8621db7b94b70ca1e8.svg";